import omit from 'lodash/omit';
import { SearchParams } from '../../search.types';
import { WatcherSearchQueryParams } from '../../../watchers/watchers.types';

export function getNewWatcherQueryParams(
  queryParams: WatcherSearchQueryParams & { q: string },
) {
  const params = { ...queryParams, query: queryParams.q };
  return omit(params, ['q']);
}

export function getSnakeNewWatcherQueryParams(queryParams: SearchParams) {
  const params = { ...queryParams, query: queryParams.q };

  return omit(params, ['q']);
}

export function formatQueryWatcherModal(
  queryParameters: WatcherSearchQueryParams,
) {
  return queryParameters.selectedKeywords &&
    queryParameters.selectedKeywords.length
    ? [queryParameters.query, ...queryParameters.selectedKeywords].join(
        '\u0020',
      )
    : queryParameters.query;
}
